import type {
    State,
    User,
} from '@uipath/auth-core';
import { validateReturnUrl } from '@uipath/auth-core';

export type CallbackState = State;

/**
 * A function to get the returnTo back after returning from redirect
 *
 * Note: by default state should be present, but it can be undefined
 * if it is modified in the `AuthGuard` params
 * @param user
 * @returns `state`
 */
export function getCallbackState(user: User | void) {
    const state = user?.state as CallbackState;

    if (!validateReturnUrl(state?.returnTo)) {
        return {
            ...state,
            returnTo: '/',
        };
    }

    return state;
}

/**
 * Provide this function to `UiPathAuthProvider` if no custom callback logic is needed.
 * Otherwise, use `getCallbackState` to get the `returnTo` and redirect to that route
 * on the callback through your router.
 *
 * Note: this function takes `navigate` as a param to avoid adding `react-router` as a dependency
 * @param user
 * @param navigate `router.navigate` for react router v6, `history.push` otherwise
 */
export function onCallback(user: User | void, navigate: (to: string) => any) {
    const returnTo = getCallbackState(user).returnTo;
    navigate(returnTo);
}

